import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk } from ".";
import { GET_ALL_PRODUCT_CATEGORIES, GET_PARENT_BY_DOMAIN, GET_SELLER_PRODUCT_CATEGORIES } from "../../utils/queries";

export const sellerProductCategoriesThunk = createAsyncThunk(
    "sellerProductCategoriesSlice/sellerProductCategoriesThunk",
    createGraphQLThunk({
      query: GET_SELLER_PRODUCT_CATEGORIES,
      responseKey: "getSellerProductCategories",
      url: process.env.REACT_APP_VENDOR,
      notError: true
    })
  );

export const GetAllProductDomains = createAsyncThunk(
    "allProductDomainsSlice/GetAllProductDomains",
    createGraphQLThunk({
        query: GET_ALL_PRODUCT_CATEGORIES,
        responseKey: "getAllProductDomains",
    })
);

export const GetParentByDomain = createAsyncThunk(
    "parentByDomainSlice/GetParentByDomain",
    createGraphQLThunk({
        query: GET_PARENT_BY_DOMAIN,
        getVariables: (id) => (id),
        responseKey: "getParentCategoriesByRootId",
        notError: true
    })
);